<router-outlet></router-outlet>
<!-- <router-outlet *ngIf="showContent"></router-outlet> -->
<!-- <ap-preloader (destroyLoader)="destroyLoader($event)" *ngIf="showPreloader"></ap-preloader> -->